import { SHOW_BILLING_ADDRESS_FORM } from './BillingAddressPageConstants';

export default (state = {
    showBillingAddressForm: false
}, action) => {
    switch (action.type) {
        case SHOW_BILLING_ADDRESS_FORM:
            return Object.assign({}, state, {
                showBillingAddressForm: action.payload
            });
        default:
            return state;
    }
};